// export const  MAIN_API = "http://127.0.0.1:8000/api";
// export const  MAIN_API = "http://192.168.0.101:8000/api";
export const  MAIN_API = "https://api-db.nicode.az/public/api";
// export const  MAIN_API = "http://10.0.0.147:8000/api";